import React, {  useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useControl } from "../../controlContext";
import { useSource } from "../../sourceContext";
import { useSchema } from "../../schemaContext";
import ButtonWithLoadSpinner  from '../../../buttonWithLoadSpinner'

export function ModalContainer({objectMetadata = {}, options, children, onSubmit}){
  const controls = useControl()
  const source = useSource()
  const schemas = useSchema()
  const [show, setShow] = useState(false)
  // console.log('conman modal rendering')
  useEffect(()=>{
    if(options.show !== show) setShow(options.show)
  }, [options, show])

  function submit(){
    return onSubmit({controls, source, schemas})
  }

  function onHide() { 
    if(options.setShow) {
      console.log('hiding externally')
      options.setShow(false)
      return
    }
    setShow(false) 
  }

  return (
    <Modal show={show}>
      <Modal.Header>{objectMetadata.name || `New (${objectMetadata.type})`}</Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>Cancel</Button>
        <ButtonWithLoadSpinner variant="outline-activated" onClick={submit}>Save</ButtonWithLoadSpinner>
      </Modal.Footer>
    </Modal>
  )
}